import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

export const getUser = async () => {
  await firebase.auth().signInAnonymously();
  const user = await firebase.auth().currentUser;

  return user;
};

export const userDistanceListener = async callback => {
  const user = await getUser();

  firebase
    .database()
    .ref("user_distance/" + user.uid)
    .on("value", snap => {
      const { distanceKey } = snap.val() || {};
      callback(distanceKey);
    });
};

export const submitDistance = async (distance, distanceKey = undefined) => {
  const createUserDistance = !distanceKey;
  if (!distanceKey) {
    distanceKey = firebase
      .database()
      .ref("distance")
      .push().key;
  }

  const user = await getUser();
  if (createUserDistance) {
    firebase
      .database()
      .ref("user_distance/" + user.uid)
      .set({
        distanceKey
      });
  }

  firebase
    .database()
    .ref("distance/" + distanceKey)
    .set(distance);
};
